import React from 'react';
import Select from 'react-select';
import { Form } from 'react-bootstrap';

// Get CSS variable values (with fallbacks)
const getCSSVariable = (varName, fallback) => {
  if (typeof window !== 'undefined') {
    const value = getComputedStyle(document.documentElement).getPropertyValue(varName);
    return value.trim() || fallback;
  }
  return fallback;
};

const selectStyles = {
  control: (provided) => ({
    ...provided,
    border: `1px solid var(--color-border-select, #888)`,
    fontSize: '1em',
    minHeight: '38px',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex'
  }),
  container: (provided) => ({
    ...provided,
    width: '100%'
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'var(--color-text-placeholder, #6c757d)',
    margin: 0
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'block'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: parseInt(getCSSVariable('--z-index-react-select-menu', '9999999'), 10),
    backgroundColor: 'white',
    border: '1px solid #ccc',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
  }),
  menuList: (provided) => ({
    ...provided,
    backgroundColor: 'white',
    padding: 0,
    maxHeight: '200px'
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: parseInt(getCSSVariable('--z-index-react-select-menu', '9999999'), 10)
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected 
      ? 'var(--color-primary, #0d6efd)' 
      : state.isFocused 
        ? '#e7f3ff' 
        : 'white',
    color: state.isSelected ? 'white' : '#212529',
    cursor: 'pointer'
  })
};

const SelectField = ({
  label,
  name,
  value,
  onChange,
  options,
  placeholder = 'Select...',
  isDisabled = false,
  isSearchable = true,
  isClearable = true,
  required = false,
  labelColor = '#d32f2f',
  className = '',
  ...props
}) => {
  return (
    <Form.Group className={`mb-3 ${className}`}>
      {label && (
        <Form.Label style={{ color: labelColor }}>
          {required && <span className="text-danger">*</span>}
          <strong>{label}</strong>
        </Form.Label>
      )}
      <Select
        name={name}
        value={value}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        isClearable={isClearable}
        styles={selectStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuPlacement="auto"
        classNamePrefix="react-select"
        screenReaderStatus={() => ''}
        aria-live="off"
        {...props}
      />
    </Form.Group>
  );
};

export default SelectField;

